"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputVariants = exports.helperTextDanger = exports.helperTextWarning = exports.helperTextCompact = exports.helperTextComfortable = exports.helperTextBase = void 0;

var _stylitas = require("@creditas/stylitas");

const helperTextBase = ({
  theme,
  width = '280px'
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.supportForm(theme)};
  margin-top: 4px;
  width: ${width};
  color: ${_stylitas.utilities.palette.color(theme, 'neutral06')};
  min-width: 205px;
`;

exports.helperTextBase = helperTextBase;

const helperTextComfortable = ({
  size
}) => size === 'comfortable' && (0, _stylitas.css)`
    top: 39px;
  `;

exports.helperTextComfortable = helperTextComfortable;

const helperTextCompact = ({
  size
}) => size === 'compact' && (0, _stylitas.css)`
    top: 31px;
  `;

exports.helperTextCompact = helperTextCompact;

const helperTextWarning = ({
  theme,
  variant,
  disabled
}) => variant === 'warning' && !disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'warning')};
  `;

exports.helperTextWarning = helperTextWarning;

const helperTextDanger = ({
  theme,
  variant,
  disabled
}) => variant === 'danger' && !disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'danger')};
  `;

exports.helperTextDanger = helperTextDanger;

const inputVariants = ({
  relatedInputType
}) => {
  switch (relatedInputType) {
    case 'textarea':
      return (0, _stylitas.css)`
        text-align: right;
      `;

    default:
      return (0, _stylitas.css)``;
  }
};

exports.inputVariants = inputVariants;